import ApiService from "./ApiService";

export default class remarkService {
    static addNewRemark = (remark) =>ApiService.post("/admin/add-new-remark", remark);
}
